import { captureException } from '@sentry/react'
import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import { z } from 'zod'
import {
	type HttpGetPresignBulkPhotosProPhotosOptions,
	httpGetPresignBulkPhotosProPhotos
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { Media } from '@/features/service-vetting/types.ts'
import { parseAxiosPromise } from '@/helpers/utils'
import { MUTATION_KEYS } from '@/query-client'

const BulkPresignedPhotosResponse = z.array(
	z.object({ media: Media, presignedUrl: z.string().url() })
)
export type BulkPresignedPhotosResponse = z.infer<
	typeof BulkPresignedPhotosResponse
>

export const useBulkPresignedServicePhotosProPhotos = ({
	urlParams,
	options
}: {
	urlParams: HttpGetPresignBulkPhotosProPhotosOptions['urlParams']
	options?: UseMutationOptions<
		BulkPresignedPhotosResponse,
		unknown,
		Omit<HttpGetPresignBulkPhotosProPhotosOptions['payload'], 'mutationFn'>
	>
}) => {
	return useMutation({
		mutationKey: [MUTATION_KEYS.SERVICES_PHOTO_PRESIGNED, urlParams],
		mutationFn: (payload) =>
			parseAxiosPromise({
				axiosPromise: httpGetPresignBulkPhotosProPhotos({
					urlParams,
					payload
				}),
				responseShape: BulkPresignedPhotosResponse,
				onZodError: captureException
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
